import { SOCIALS } from "./site";
import { SERA } from "./sera";

/**
 * The link-in-bio decks.
 *
 * TWO PAGES, ONE COMPONENT. Each Instagram account gets its own list, because
 * the people arriving are different:
 *
 *   /links   <- @ivish_ai        the company account
 *   /sahith  <- @sahithvutukuri  the CEO's own account
 *
 * These moved here from the VerbX marketing site in October 2026: a bio link is
 * the company's front door, so it belongs on the company's domain rather than
 * on a product's.
 *
 * THIS FILE IS THE PAGE. Order here is order on the page, and the first entry
 * takes most of the taps, so treat the ordering as an editorial decision rather
 * than a detail.
 *
 * `accent` is a hex from the tailwind palette, used only on the row number.
 */

const IVISH_SITE = "/";
const VERBX_SITE = "https://verbxeco.com/";
const ONE_CONSOLE = "https://one.verbxeco.com";

/* Play's `pcampaignid=web_share` is a share-attribution tag, tied to the share
   that produced the link rather than to the app. Dropped on all three. */
const SERA_PLAY = SERA.playStore.split("&")[0];
const TRAVEL_PLAY =
  "https://play.google.com/store/apps/details?id=com.verbx.travelapp";
const PERSONAL_PLAY =
  "https://play.google.com/store/apps/details?id=com.ivish.verbx";

const EMBER = "#E26426";
const EMBER_DEEP = "#AD4613";
const AQUA_DEEP = "#0F616D";
const INK_MUTED = "#55555E";
const INK_FAINT = "#6E6E78";

/* ---- The company: @ivish_ai ---------------------------------------------
   Leads with the parent company, then the ecosystem, then the four things a
   visitor can actually open today. Sera points at Play rather than at its page
   on this site: someone arriving from a bio has come to get the app. */
export const COMPANY_LINKS = [
  {
    label: "Ivish AI",
    sub: "Website",
    href: IVISH_SITE,
    accent: INK_MUTED,
  },
  {
    label: "VerbX",
    sub: "Website",
    href: VERBX_SITE,
    accent: EMBER,
    external: true,
  },
  {
    label: "Sera",
    sub: "Google Play",
    href: SERA_PLAY,
    accent: EMBER_DEEP,
    external: true,
  },
  {
    label: "VerbX One",
    sub: "Sign in",
    href: ONE_CONSOLE,
    accent: AQUA_DEEP,
    external: true,
  },
  {
    label: "VerbX Travel",
    sub: "Google Play",
    href: TRAVEL_PLAY,
    accent: INK_FAINT,
    external: true,
  },
  {
    label: "VerbX Personal",
    sub: "Google Play",
    href: PERSONAL_PLAY,
    accent: EMBER,
    external: true,
  },
];

/* The company's own three, straight from site.js so they cannot drift. */
export const COMPANY_SOCIALS = [
  { label: "Instagram", href: SOCIALS.instagram },
  { label: "X", href: SOCIALS.x },
  { label: "LinkedIn", href: SOCIALS.linkedin },
];

/* ---- The CEO: @sahithvutukuri -------------------------------------------
   A person's bio link, so it opens on the person: LinkedIn first, because that
   is what someone who has just heard him speak goes looking for. Then the three
   things he is responsible for, then back to the account they came from.

   No separate social row on this page: his two accounts are already rows here,
   and repeating them at the foot would only be a second place to leave. */
export const CEO_LINKS = [
  {
    label: "LinkedIn",
    sub: "Sahith Vutukuri",
    href: "https://www.linkedin.com/in/vutukuri-sahith/",
    accent: AQUA_DEEP,
    external: true,
  },
  {
    label: "Ivish AI",
    sub: "Website",
    href: IVISH_SITE,
    accent: INK_MUTED,
  },
  {
    label: "VerbX",
    sub: "Website",
    href: VERBX_SITE,
    accent: EMBER,
    external: true,
  },
  {
    label: "Sera",
    sub: "Google Play",
    href: SERA_PLAY,
    accent: EMBER_DEEP,
    external: true,
  },
  {
    /* Supplied with a `?psln=` share token attached. That is tied to the share
       that produced it, not to the profile, so it is dropped. */
    label: "Instagram",
    sub: "@sahithvutukuri",
    href: "https://www.instagram.com/sahithvutukuri",
    accent: INK_FAINT,
    external: true,
  },
];
